/**
 * This props is used to build the HTMLLinkElement
 * for the brand styles.
 */
export const propsToCDNLink = {
    parent: 'head',
    type: 'link',
    id: 'cdn-styles',
    rel: 'stylesheet',
};

export const porscheThemeText = 'porsche';
export const defaultBronsonTheme =
    'https://cdn.bronson.vwfs.tools/generic/v/1.0.0-beta.30/css/style.min.css';

/**
 * This constant is used to define the different
 * cdn to brand styles.
 */
export const bronsonThemes = [
    {
        theme: 'audi',
        cdn: 'https://cdn.bronson.vwfs.tools/audi/v/7.29.0/css/style.min.css',
    },
    {
        theme: 'vw6',
        cdn: 'https://cdn.bronson.vwfs.tools/vw6/v/1.29.0/css/style.min.css',
    },
    {
        theme: 'seat',
        cdn: 'https://cdn.bronson.vwfs.tools/seat/v/7.29.0/css/style.min.css',
    },
    {
        theme: 'skoda',
        cdn: 'https://cdn.bronson.vwfs.tools/skoda/v/7.29.0/css/style.min.css',
    },
    {
        theme: 'bluelabel',
        cdn: 'https://cdn.bronson.vwfs.tools/bluelabel/v/7.29.0/css/style.min.css',
    },
    {
        theme: 'bluelabelBanking',
        cdn: 'https://cdn.bronson.vwfs.tools/bluelabel-banking/v/7.29.0/css/style.min.css',
    },
    {
        theme: 'bluelabelApplication',
        cdn: 'https://cdn.bronson.vwfs.tools/bluelabel-application/v/7.29.0/css/style.min.css',
    },
    {
        theme: 'bluelabelMagazine',
        cdn: 'https://cdn.bronson.vwfs.tools/bluelabel-magazine/v/7.29.0/css/style.min.css',
    },
    {
        theme: 'ubility',
        cdn: 'https://cdn.bronson.vwfs.tools/ubility/v/1.0.0-beta.19/css/style.min.css',
    },
    {
        theme: 'default',
        cdn: 'https://cdn.bronson.vwfs.tools/default/v/7.29.0/css/style.min.css',
    },
    {
        theme: 'porsche',
        cdn: 'https://cdn.bronson.vwfs.tools/generic/v/1.0.0-beta.30/css/style.min.css',
    },
    {
        theme: 'vw5',
        cdn: 'https://cdn.bronson.vwfs.tools/vw/v/7.29.0/css/style.min.css',
    },
];

/**
 * this constant is to define the minimus downpayment for
 * financial products.
 */
export const minimumDownpaymentByBrandFinancialProduct = {
    porsche: [
        {
            financialProductTypeId: 1,
            minimum: 0.2,
        },
        {
            financialProductTypeId: 2,
            minimum: 0.25,
        },
    ],
};

/**
 * This const define a default minimum down-payment
 * value allowed for the financial products.
 */
export const defaultMinimumValue = 0.2;

/**
 * This const define a default financial product type Id
 * for make a sort of the financial products, this const
 * define what is the first financial product in the list.
 */
export const defaultFinancialProductTypeId = 2;

/**
 * This constant is used in the error component to indicate
 * what topic need to use the alarm service.
 */
export const queryParamNotifyMismatch = '?notifyMismatch=true';
